import script from "./VSCardsMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./VSCardsMobile.vue?vue&type=script&setup=true&lang=js"

import "./VSCardsMobile.vue?vue&type=style&index=0&id=64967bd7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64967bd7"]])

export default __exports__